"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.converter = void 0;
const uuid_1 = require("uuid");
const common_1 = require("@finley-technologies/common");
const conversionUtils_1 = require("../../conversionUtils");
const types_1 = require("../../operations/calcagent/types");
const registry_1 = require("../../registry");
const types_2 = require("./types");
const uinode_1 = require("./uinode");
// converts intermediate records to 1 or more UI nodes.
const intermediateToUINodes = (tape) => {
    (0, common_1.finleyAssert)(uinode_1.file_generatedReceivableResponseTape.isIntermediateRecord(tape), `must be a ${types_2.artifactType} record`);
    const { id, artifactSlug, creditFacilitySlug } = tape;
    const { tapeDescription, operationDescription, useReceivableWaivers, } = tape.configuration;
    const tapeNode = {
        metadata: {
            tapeBuilderNodeId: id,
            tapeBuilderNodeType: types_2.nodeType,
        },
        configuration: {
            artifactSlug,
            description: tapeDescription,
        },
    };
    const operationNode = {
        metadata: {
            tapeBuilderNodeId: (0, uuid_1.v4)(),
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            description: operationDescription,
            creditFacilitySlug,
            useReceivableWaivers,
        },
    };
    return {
        operationNode,
        tapeNode,
    };
};
// converts UI nodes to intermediate records.
// returns new record and old record ids to be replaced.
const uiNodesToIntermediate = (params) => {
    const { artifactDocumentId, node, graph } = params;
    (0, common_1.finleyAssert)(uinode_1.file_generatedReceivableResponseTape.isNode(node), `uiNodesToIntermediate: node is not a ${types_2.artifactType} node: ${node.metadata.tapeBuilderNodeType}`);
    const { operationNode } = (0, conversionUtils_1.getOperationAndTapes)({
        node,
        graph,
    });
    (0, common_1.finleyAssert)(operationNode, 'uiNodesToIntermediate: operationNode is null');
    (0, common_1.finleyAssert)(registry_1.operationNodes.operation_calcAgent.isNode(operationNode), 'uiNodesToIntermediate: operationNode is not a CalcAgentOperationNode');
    const { artifactSlug, description: tapeDescription } = node.configuration;
    const { description: operationDescription, creditFacilitySlug, useReceivableWaivers, } = operationNode.configuration;
    const record = {
        id: node.metadata.tapeBuilderNodeId,
        artifactDocumentId,
        type: types_2.artifactType,
        artifactSlug,
        creditFacilitySlug,
        loanProductSlug: null,
        externalFilename: null,
        configuration: {
            tapeDescription,
            operationDescription,
            useReceivableWaivers,
        },
    };
    return {
        record,
        operationNode,
    };
};
exports.converter = {
    artifactType: types_2.artifactType,
    nodeType: types_2.nodeType,
    intermediateToUINodes,
    uiNodesToIntermediate,
};
//# sourceMappingURL=converter.js.map